import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
  },
  tagsSelectContainer: {
    minWidth: 140,
    maxWidth: 220,
    width: "100%",
    marginTop: -4,
    marginLeft: 8,
    [theme.breakpoints.down("sm")]: {
      minWidth: 110,
      maxWidth: 160,
    },
  },
}));

const TicketsOperationalTagsSelect = ({
  selectedTags = [],
  onChange,
}) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const loadTags = async () => {
      try {
        const { data } = await api.get("/tags/list?kanban=0");

        setTags(data || []);
      } catch (err) {
        toastError(err);
      }
    };

    loadTags();
  }, []);

  const handleChange = (e) => {
    const values = e.target.value || [];
    const selectedObjects = tags.filter((tag) => values.indexOf(tag.id) > -1);
    onChange(selectedObjects);
  };

  return (
    <div className={classes.tagsSelectContainer}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedTags}
          onChange={handleChange}
          style={{
            borderRadius: 8,
            height: 30,
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: "0 0 8px 8px",
              },
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={() => "Tags"}
        >
          {tags?.length > 0 &&
            tags.map((tag) => (
              <MenuItem
                dense
                key={tag.id}
                value={tag.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: tag.color || "#3f51b5",
                  }}
                  size="small"
                  color="primary"
                  checked={selectedTags.indexOf(tag.id) > -1}
                />
                <ListItemText primary={tag.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsOperationalTagsSelect;
